import { UnitSystem } from '~/_shared/types/googleMaps/googleMaps.types';
import { convertDistanceToUnitSystem } from '~/_shared/utils/distance/distance.helpers';
import { ExportReportType } from '~/exportReport/exportReportType';
import { ExportReportPrintPageWrapperComponent } from '~/exportReport/printPage/exportReportPrintPageWrapper.component';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import { ExportReportTemplateRendererComponent } from '~/exportReport/templateRenderer/exportReportTemplateRenderer.component';
import { useExportReportData } from '~/exportReport/useExportReportData';
import { useExportReportParams } from '~/exportReport/useExportReportParams';
import type { ExportReportRadiusParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

type ExportReportPrintPageProps = Readonly<{
  params: ExportReportRadiusParams;
  template: ReportTemplate;
}>;

export const ExportReportPrintPageRadiusComponent = ({ template, params }: ExportReportPrintPageProps) => {
  const { tableColumns } = useExportReportParams();
  const { getDemographicData, getDemographicLabel } = useExportReportData({
    tableColumns,
    template,
  });

  if (!template) {
    return null;
  }

  return (
    <ExportReportPrintPageWrapperComponent>
      <ExportReportTemplateRendererComponent
        template={template}
        dataSourceColumns={tableColumns}
        summaryProps={{
          latLng: {
            lat: params.data.center.lat,
            lng: params.data.center.lng,
          },
          heading: params.data.title,
        }}
        mapProps={{
          center: params.data.center,
          type: ExportReportType.Radius,
          radiusInMeters: convertDistanceToUnitSystem({
            distance: params.data.radius,
            currentUnitSystem: params.data.unit,
            targetUnitSystem: UnitSystem.metric,
          }) * 1000,
        }}
        getDemographicLabel={getDemographicLabel}
        getDemographicData={getDemographicData}
      />
    </ExportReportPrintPageWrapperComponent>
  );
};
